import { Component, Input } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { FromScreen } from 'src/app/models/from-screen';
import { Action, ActionType } from 'src/app/models/action';
import { TypeAction } from '../../../models/record-external';
import { Util } from 'src/app/util';
import { LoginDialogComponent } from '../../../login/components/login-dialog/login-dialog.component';
import { ExternalVideoModel } from 'src/app/_core/state/dialogs/external-video/model/external-video-data.model';
import { openWindow } from '../../../_core/utils/open-window';

@Component({
  selector: 'app-external-link-button',
  templateUrl: './external-link-button.component.html',
  styleUrls: ['./external-link-button.component.scss', '../base-button.scss'],
})
export class ExternalLinkButtonComponent extends BaseButtonComponent {
  @Input()
  from: FromScreen;

  @Input()
  isMoreOption: string;

  @Input()
  recordIcon: string;

  openExternalLink() {
    const isIframe = this.record.externalLink.includes('<iframe');
    const isLearningExperience =
      !this.configService.shouldHideBookClub() &&
      this.record.externalLink.includes(this.configService.get().bookClubUrl);

    if (this.record.typeAction === TypeAction.OPEN_URL) {
      openWindow(this.record.externalLink);
      return;
    }

    if (isLearningExperience) {
      return this.doLearningExperienceAction();
    }

    const action: Action = {
      type: ActionType.OPEN_EXTERNAL,
      recordId: this.record.id,
    };
    if (this.record.typeAction === TypeAction.AWS_COURSES) {
      this.apiService
        .getExternalLink(this.record.id)
        .subscribe((value) => (this.record.externalLink = value.externalLink));
    }

    this.doAction(() => {
      this.apiService.remoteView(this.record.id, this.from);
      if (isIframe) {
        return this.openDialog();
      }

      window.open(this.record.externalLink, '_blank', 'noopener');
    }, action);
  }

  private openDialog() {
    const externalVideoModel: ExternalVideoModel = {
      title: this.record.title,
      link: this.record.externalLink,
      format: this.record.formats,
      userId: this.userService.getUserId(),
      resourceId: this.record.id,
      isFromExternalDb: false,
    };

    this.externalVideoDialogFacade.openDialog(externalVideoModel);
  }

  private doLearningExperienceAction() {
    if (this.authService.isAuthenticated()) {
      this.getTokenAndRedirectToLearningExperience();
    } else {
      const customLoginUrl = this.configService.get().customLoginUrl;
      if (customLoginUrl) {
        this.authService.getExternalLoginUrl(customLoginUrl).subscribe((url) => {
          localStorage.setItem('returnFromLearningExperience', this.router.url);
          localStorage.setItem('redirectToLearningExperience', 'Y');
          localStorage.setItem('clubId', this.getClubId());
          window.location.href = url;
        });
      } else {
        this.openLoginDialog(false);
      }
    }
  }

  private openLoginDialog(showRegisterForm = false) {
    this.dialog
      .open(LoginDialogComponent, {
        data: {
          showRegisterForm: showRegisterForm,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.getTokenAndRedirectToLearningExperience();
        } else {
          const action = Util.getAction();
          if (action) {
            Util.setAction({
              ...action,
              type: ActionType.NONE,
            });
          } else {
            Util.removeAction();
          }
        }
      });
  }

  private getTokenAndRedirectToLearningExperience() {
    const clubId = this.getClubId();

    const params = {
      patronId: this.userService.getUserId(),
      clubId: clubId,
    };

    this.apiService.getLinkToBookclub(params).subscribe((url) => {
      this.apiService.remoteView(this.record.id, this.from);
      if (!url.includes('clubId')) {
        url = url + '&clubId=' + params['clubId'];
      }
      window.open(url, '_blank', 'noopener');
    });
  }

  private getClubId() {
    return this.record.learningExperienceId
      ? this.record.learningExperienceId
      : this.record.externalLink.slice(this.record.externalLink.lastIndexOf('/') + 1);
  }
}
